import { useOutletContext } from 'react-router-dom';
import { TimeFrameDateRange } from '../components/TimeFramePicker';

export type IntentContext = {
  options: { products: string[]; verticals: string[] };
  selectedProducts: string[];
  selectedVerticals: string[];
  dateRange: TimeFrameDateRange | null;
};

export const useIntentContext = () => useOutletContext<IntentContext>();
